module.exports = __webpack_public_path__ + "static/media/80s-skimoguls.f0c95baf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/80s-skimoguls.mp4
// module id = 934
// module chunks = 0